import React from 'react'; 
 
import axios from 'axios'; 
import {base_url} from '../common/Constants';
import { Link } from 'react-router-dom'; 
 

 
class CareersContent extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            careers : this.props.careers,
            loading : 0
        }
    }
 
    render()
    { 
        const content = JSON.parse(localStorage.getItem("pagecontents"));
        const linkedin = base_url+'assets/_nuxt/img/ln.a025388.svg';
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (
        <div>
           <section class="section-padded">
            <div data-aos="fade-up" data-aos-duration="1000" class="content text-center aos-init aos-animate">
            <h1>{content[4].title}</h1> <div class="spacer50"></div>  
       
           
           <div dangerouslySetInnerHTML={{ __html:  content[4].description }} />

          </div>
          <div className="keyblocks">
      <div
        data-aos-delay="100"
        data-aos="fade-down"
        data-aos-duration="500"
        className="kb-block aos-init aos-animate"
      >
        <div className="kb-icon">
          <img src={base_url+"assets/_nuxt/img/responsible.483aa2b.png"} alt="Creating Trust icon" />
        </div>
        <div className="kb-bottom">Respectful</div>
        <div className="kb-top">Creating Trust</div>
      </div>

      <div
        data-aos-delay="200"
        data-aos="fade-down"
        data-aos-duration="500"
        className="kb-block aos-init aos-animate"
      >
        <div className="kb-icon">
          <img src={base_url+"assets/_nuxt/img/respect.b78d364.png"} alt="Building Legacy icon" />
        </div>
        <div className="kb-bottom">Responsible</div>
        <div className="kb-top">Building Legacy</div>
      </div>

      <div
        data-aos-delay="300"
        data-aos="fade-down"
        data-aos-duration="500"
        className="kb-block aos-init aos-animate"
      >
        <div className="kb-icon">
          <img src={base_url+"assets/_nuxt/img/collab.8c8659a.png"} alt="Enabling Relationships icon" />
        </div>
        <div className="kb-bottom">Collaborative</div>
        <div className="kb-top">Enabling Relationships</div>
      </div>

      <div
        data-aos-delay="400"
        data-aos="fade-down"
        data-aos-duration="500"
        className="kb-block aos-init aos-animate"
      >
        <div className="kb-icon">
          <img src={base_url+"assets/_nuxt/img/prog.25806f9.png"} alt="Driving Change icon" />
        </div>
        <div className="kb-bottom">Progressive</div>
        <div className="kb-top">Driving Change</div>
      </div>

      <div
        data-aos-delay="500"
        data-aos="fade-down"
        data-aos-duration="500"
        className="kb-block aos-init aos-animate"
      >
        <div className="kb-icon">
          <img src={base_url+"assets/_nuxt/img/efficient.9d169ef.png"} alt="Delivering Results icon" />
        </div>
        <div className="kb-bottom">Efficient</div>
        <div className="kb-top">Delivering Results</div>
      </div>

      <div
        data-aos-delay="600"
        data-aos="fade-down"
        data-aos-duration="500"
        className="kb-block aos-init aos-animate"
      >
        <div className="kb-icon">
          <img src={base_url+"assets/_nuxt/img/safe.8934a52.png"} alt="Acting Safely icon" />
        </div>
        <div className="kb-bottom">100% HSE</div>
        <div className="kb-top">Acting Safely</div>
      </div>
    </div>
   

        </section> <section className="section-fullwidth ln-bg" style={{backgroundImage:'url('+base_url+'assets/_nuxt/img/career_2.jpg)', backgroundSize: 'cover'}}>
  <div className="section-padded content ln-content">
    <div
      data-aos-delay="600"
      data-aos="zoom-in"
      data-aos-duration="500"
      className="ln-content-inner aos-init aos-animate"
    >
      <a
        target="_blank"
        href="https://www.linkedin.com/company/emiratesspecialized/jobs/"
        rel="noopener noreferrer"
      >
        <h1>
          Stay up to date <br />
          on ESCO‘s Careers
        </h1>

        <p>
          We post our career opportunities on Linkedin. Visit and follow our
          Jobs section on our Corporate Linkedin Page.
        </p>

        <img
          src={linkedin}
          alt="LinkedIn Logo"
          style={{ width: "50px", margin: "auto" }}
        />
      </a>
    </div>
  </div>
</section>
        </div>
    );
}

}

export default CareersContent;